/**
 * My subscription swaps the mobile carousel for the desktop/tablet compare table at
 * 667px (iPhone SE landscape) rather than Nebula's 768px `tabletPortrait` breakpoint.
 * The layout styles have to share that threshold, otherwise 667–767px renders the
 * compare-table markup with none of its grid applied.
 */
export const TABLET_MIN_WIDTH = 667;

export const tabletMin = `(min-width: ${TABLET_MIN_WIDTH}px)`;

/** Nebula's `tabletPortrait` breakpoint — the width the tablet design was drawn against. */
const NEBULA_TABLET_PORTRAIT_WIDTH = 768;

/**
 * 667–767px only. The four compare-table columns are ~30px narrower here than the tablet
 * design allows for, so the plan cards need tighter padding and type to stay readable.
 */
export const compactTablet = `${tabletMin} and (max-width: ${NEBULA_TABLET_PORTRAIT_WIDTH - 1}px)`;
